import * as React from 'react';
import { Trans } from 'react-i18next';
import { Text } from '@wix/design-system';
import { RootStore, withInjectedRootStore } from '../../../providers';
import s from './SaleBanner.scss';
import { usePageModeContext } from '../../../providers/PageMode/PageMode.provider';
import classNames from 'classnames';

interface ResellerSaleBannerCompProps {
    rootStore: RootStore;
}

const ResellerSaleBannerContentComp: React.FunctionComponent<
    ResellerSaleBannerCompProps
> = ({ rootStore }) => {
    const { discountPercent } = rootStore.appStore.appContext.saleParams;
    const { name: resellerBrandingName } = rootStore.appStore.resellerOfferingBrandingInfo || {};
    const { theme } = usePageModeContext();

    return (
        <Text weight='bold' size='small'>
            <Trans
                i18nKey={'premium-purchase-plan.reseller_sale.header'}
                values={{ percent: discountPercent || '50', resellerName: resellerBrandingName }}
            >
                <span className={classNames(s.resellerSaleDiscountColor, theme)}>
                    SAVE {{ percent: discountPercent || '50' }}%
                </span>
                rest
            </Trans>
        </Text>
    );
};

export const ResellerSaleBannerContent = withInjectedRootStore(ResellerSaleBannerContentComp);
